import {
  getRequest,
  getRequestOfExam,
  postRequestByJson,
  putRequest,
  deleteRequest,
  uploadFileRequest,
} from "@/libs/axios";
import { Message } from "element-ui";
function myThen(data) {
  if (data.result) {
    return Promise.resolve(data.data);
  } else {
    Message.error(data.failMsg);
    return Promise.reject(data.failMsg);
  }
}
export const mainPageAnalysis = (params = {}) => {
  return postRequestByJson("/api/analysis/v1/query/statisticsNum", params).then(
    myThen
  );
};
export const basicAnalysis = (params = {}) => {
  return postRequestByJson(
    "/api/exam/v1/statisticsAnalysis/basic-analysis",
    params
  ).then(myThen);
};
export const questionAnalysis = (params = {}) => {
  return postRequestByJson(
    "/api/exam/v1/statisticsAnalysis/question-analysis",
    params
  ).then(myThen);
};
export const getMainPageNewData = (params = {}) => {
  return postRequestByJson("/api/analysis/v1/query/studentNum", params).then(
    myThen
  );
};
